import React, { useState } from 'react';
import AdminSidebar from './AdminSidebar';
import { FiMenu } from 'react-icons/fi';

/**
 * AdminLayout Component
 * Wrapper layout with AdminSidebar for admin pages
 * Provides consistent layout across all admin pages
 * Now with mobile responsive sidebar toggle
 */
const AdminLayout = ({ children, title = "Admin Dashboard" }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <AdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main Content Area */}
      <div className="lg:ml-64">
        {/* Header */}
        <div className="bg-white shadow-sm border-b border-gray-200">
          <div className="px-4 lg:px-8 py-6">
            <div className="flex items-center space-x-4">
              {/* Hamburger Menu - visible only on mobile */}
              <button
                onClick={() => setSidebarOpen(true)}
                className="lg:hidden text-gray-600 hover:text-gray-900 transition-colors"
              >
                <FiMenu className="w-6 h-6" />
              </button>
              <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            </div>
          </div>
        </div>

        {/* Page Content */}
        <main className="p-4 lg:p-8">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
